import { forwardRef, type Ref, type SVGProps } from "react";
const IconPanelLeftOpenFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M18.73 12.405a1 1 0 0 1 1.413 0l2.968 2.968c.39.39.39 1.025 0 1.415l-3.015 3.016a1 1 0 0 1-1.414-1.415l2.308-2.309-2.26-2.261a1 1 0 0 1 0-1.414"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26.5 2.002c1.857-.067 3.422 1.276 3.499 3V28c-.078 1.073-.999 1.927-2.154 2H4.155C3 29.927 2.08 29.073 2.001 28V5.002c.077-1.724 1.642-3.067 3.5-3zm0 2-13.074-.049v23.998l14.419.05v-23c-.09-.613-.682-1.053-1.346-1"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconPanelLeftOpenFilledSVG);
ForwardRef.displayName = "IconPanelLeftOpenFilled";
export { ForwardRef as IconPanelLeftOpenFilled };
